enum MigrationRoutes {
  MIGRATION_START = 'MIGRATION_START',
  MIGRATION_CONFIRM_BANK_ACCOUNT = 'MIGRATION_CONFIRM_BANK_ACCOUNT',
  MIGRATION_FAQ = 'MIGRATION_FAQ',
  MIGRATION_CA_GET_STARTED = 'MIGRATION_CA_GET_STARTED',
  MIGRATION_CA = 'MIGRATION_CA'
}

export { MigrationRoutes };
